import requests2 from "./requests2";
import qs from 'qs'
// import mockRequests from "./mockRequests";
//登录的接口:请求体携带参数 phone&&password
// export const reqUserLogin = (data)=>{
//     //requests({url:`api.php?op=vote_review&act=login`,method:'post',data});
//     console.log('login request');
//     return mockRequests({url:`/login`,method:'post',data});
// };

export const reqArea = (data, params)=>{
    console.log('data',data);
    return requests2({
        method: 'get',
        url: 'uploadfile/json/region_'+data.region_id+'.json?'+Math.floor(Math.random() * 9999),
        data: qs.stringify(data),
        params: data 
    })
}

export const reqLessionList = (data, params)=>{
    console.log('data',data);
    // 图文课程（type=2）使用 art_ 前缀静态 JSON，视频课程沿用原文件名
    // gid>0 时读取对应分组的静态 JSON（{gid}_{page}.json），否则读取全部内容（{page}.json）
    const prefix = (Number(data.type) === 2) ? 'art_' : '';
    const filename = (data.gid && data.gid > 0) ? prefix + data.gid + '_' + data.page : prefix + data.page;
    return requests2({
        method: 'get',
        url: 'uploadfile/json/learn/'+data.learnid+'_learn/'+filename+'.json?'+Math.floor(Math.random() * 9999),
        data: qs.stringify(data),
        params: data 
    })
}
export const reqLessionInfo = (data, params)=>{
    console.log('data',data);
    return requests2({
        method: 'get',
        url: 'uploadfile/json/learn/'+data.learnid+'_lession/'+data.lessionid+'.json?'+Math.floor(Math.random() * 9999),
        data: qs.stringify(data),
        params: data 
    })
}

export const reqQuestionList = (data, params)=>{
    console.log('data',data);
    return requests2({
        method: 'get',
        url: 'uploadfile/json/question.json?'+Math.floor(Math.random() * 9999),
        data: qs.stringify(data),
        params: data 
    })
}

export const reqExamList = (data, params)=>{
    console.log('data',data);
    return requests2({
        method: 'get',
        url: 'uploadfile/json/exam_215.json?'+Math.floor(Math.random() * 9999),
        data: qs.stringify(data),
        params: data 
    })
}

